<template lang="pug">
    include RegisterFinish.pug
</template>

<script>
import _ from "underscore";
import moment from "moment";
import Wizard from "@/components/register/Wizard";
import Api from "@/components/services/Api";
import Datepicker from 'vuejs-datepicker';
import {availableDays, availableMonths, availableYears} from "./CalendarUtils";
import { mapState } from 'vuex';

export default {
  name: 'RegisterFinish',
  components: {Wizard, Datepicker},
  data() {
    return {
      address1: "",
      address2: "",
      administrativeZone: null,
      country: null,
      availableDays,
      availableMonths,
      availableYears,
      birthdate_day: '',
      birthdate_month: '',
      birthdate_year: '',
      courses: [],
      direct_phone: "mobile",
      email2: "",
      email: "",
      ethic: false,
      firstname: '',
      foreign_language: null,
      gender: null,
      lastname: '',
      levels: 0,
      levels_selected: [],
      mobile: "",
      password2: "",
      password: "",
      phone: "",
      postal_address: false,
      practic: false,
      privacy: false,
      public_data: true,
      step: 2,
      terms: false,
      title: "sr",
      zip: "",
      uuid: null,
      remoteForm: {
        action: null,
        level5: false,
        level4: false,
        level3: false,
        level3Courses: [],
        level4Courses: [],
        level5Courses: [],
        primeros_auxilios_expiry: null,
        rcp_expiry: null,
      }
    }
  },
  computed: _.extend(mapState([
    "context", "token",
  ]), {
    valid: function() {
      if (this.step == 2) {
        if (this.password != this.password2) {
          return false
        }
        if (this.email != this.email2) {
          return false
        }
        if (!this.password || !this.password.length) {
          return false
        }
        if (!this.birthdate_day || !this.birthdate_month || !this.birthdate_year) {
          return false
        }
        if (!this.email || !this.email.length) {
          return false
        }
        if (!this.ethic || !this.practic || !this.privacy || !this.terms) {
          return false
        }

        if (_.isNull(this.gender) || _.isNull(this.foreign_language)) {
          return false
        }
      } else if (this.step == 3) {
        if (!this.remoteForm.level3 && !this.remoteForm.level4 && !this.remoteForm.level5) {
          return false
        }
      }

      return true
    },
  }),
  created() {
    const _this = this;
    let partialRegister = localStorage.getItem(window.PREFIX + "partial_register");
    if (partialRegister && !_.isEmpty(partialRegister) && partialRegister != "null") {
      this.uuid = partialRegister;
      this.step = 3;

      // Ask if the register have been completed
      Api.getPaymentConfirmation(this.uuid).then(response => {
        let data = response.data;
        if (!data.uuid_exists || (data.user_registered && data.uuid_exists)) {
          localStorage.removeItem(window.PREFIX + "partial_register");
          setTimeout(function() {
            window.location.reload();
          }, 0);
        }
      }).catch();

    } else {
      this.step = 2;
    }

    // Send welcome email
    Api.welcomeEmail(this.token).then(response => {
      // done
    }).catch()

    this.remoteForm.action = Api.getApiUrl() + "/esreps/register-second-form/";

    Api.getFormConfiguration().then(response => {
      _this.courses = response.data.items

      _.each(_this.courses, course => {
        switch(parseInt(course.level, 10)) {
          case 3:
            _this.remoteForm.level3Courses.push(JSON.parse(JSON.stringify(course)))
            break
          case 4:
            _this.remoteForm.level4Courses.push(JSON.parse(JSON.stringify(course)))
            break
          case 5:
            _this.remoteForm.level5Courses.push(JSON.parse(JSON.stringify(course)))
            break
        }
        if (parseInt(course.level) > _this.levels) _this.levels = parseInt(course.level)
      });
    }).catch(err => {
      console.log({err})
    });
  },
  methods: {
    partialRegister: function(uuid) {
      this.uuid = uuid;
      localStorage.setItem(window.PREFIX + "partial_register", uuid);
    },
    customFormatter: function(date) {
      let result = moment(date).format('DD/MM/YYYY');
      return result;
    },
    nextStep() {
      const _this = this;

      // First logic of the step
      if (this.step == 2) {
        // Register form
        Api.registerUser({
          title: this.title,
          firstname: this.firstname,
          lastname: this.lastname,
          administrativeZone: this.administrativeZone,
          country: this.country,
          birthdate_day: this.birthdate_day,
          birthdate_month: this.birthdate_month,
          birthdate_year: this.birthdate_year,
          password: this.password,
          public_data: this.public_data,
          address1: this.address1,
          address2: this.address2,
          email: this.email,
          zip: this.zip,
          phone: this.phone,
          mobile: this.mobile,
          gender: this.gender,
          foreign_language: this.foreign_language,
        }).then(response => {
          let data = response.data;
          if (data.hasOwnProperty("uuid")) {
            // all ok!
            _this.partialRegister(data.uuid);
            _this.step += 1;
          } else {
            let error = data.error;

            if (error == "EMAIL_DUPLICATED") {
              _this.$notify({
                group: "esreps",
                type: 'warn',
                title: "Error en el registro",
                text: "El correo electrónico ya está registrado en la plataforma"
              });
            }
          }
        }).catch(err => {
          console.log({err});
        });
      } else if(this.step == 3) {
        // Submit the form
        let form = document.getElementById("secondForm");
        form.submit();
      } else {
        this.step += 1;
      }
    },
    backStep() {
      this.step -= 1;
    },
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "RegisterStep1";
@import "RegisterFinish";
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterFinish.vue